import { Component, OnInit, Input } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ModalService } from "../../../core/modal.service";
import { ApiService } from 'src/app/core/api.service';
import { ApiResponse } from 'src/app/shared/interfaces/api-response';
import { HttpClient } from '@angular/common/http';
import { DatePipe } from '@angular/common';
import { NotificationService } from "src/app/core/notification.service";
import { formdata } from 'src/app/shared/interfaces/formdata';

@Component({
  selector: 'app-reports-modal',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.css']
})
export class ReportsModalComponent implements OnInit {
  title: string = "Reports Modal";
  repParams: any[] = [];
  reportEndPoint: string = "";
  strikeID: number = 0;
  strikeName: string = "";

  reportForm!: FormGroup;

  reportValid: boolean = false

  constructor(
    private apiService: ApiService,
    private modalService: ModalService,
    private fb: FormBuilder,
    private http: HttpClient,
    private notificationService: NotificationService,

  ) { }

  ngOnInit(): void {
    if (this.repParams && this.repParams.length > 0) {
      this.initializeForm();
    }
  }

  initializeForm() {

    if (this.repParams && this.repParams.length > 0) {

      const formGroup: { [key: string]: any } = {};

      this.repParams.forEach(param => {

        formGroup[param.name] = [param.value, Validators.required];

      });
    
      this.reportForm = this.fb.group(formGroup);

    }
    
  }

  async generateReport() {
    try {
      const dynamicEndpoint = this.repParams && this.repParams.length > 0
        ? this.constructDynamicEndpoint(this.reportForm.value)
        : this.constructDynamicEndpoint({});
  
      const response: ApiResponse = await this.apiService.get(dynamicEndpoint);
  
      if (response.success) {
        this.notificationService.displaySuccess(`${this.title} Successfully Generated`);
        this.displayReport(response.body);
      } else {
        this.notificationService.displayError(`${this.title} Failed to Generate: ${response.errorMessage}`);
      }
    } catch (error) {
      this.notificationService.displayError(`${this.title} Failed to Generate: ${error}`);
    } finally {
      this.modalService.closeModal();
    }
  }

  displayReport(reportLink: string): void {
    // Open the report link in a new tab
    // We changed the following in order to trigger a download of the report 
    // to the browser instead of opening a new window, this was done mainly 
    // due to issues with the deletion proccess
    try {
      const a = document.createElement('a')
    a.href = reportLink
    a.download = String(reportLink.split('/').pop())
    document.body.appendChild(a)
    a.click()
    document.body.removeChild(a)
    }
    catch {
      console.error('Error downloading  report:', Error);
      this.notificationService.displayError('Report failed!!!');
    }
  }
  


  reportEnpointBaseGenerator(endpoint: string, formData: any): string {

    if (formData.housename) {

      const housedata = formData.housename.split(',');
      endpoint += `${this.reportEndPoint}/${housedata[0]}?housename=${encodeURIComponent(housedata[1])}`;
      delete formData.housename

    } else if (formData.format) {

      endpoint += `${this.reportEndPoint}/${this.strikeID}/${formData.format}?`;

      if (this.strikeName) {

        endpoint += `StrikeName=${encodeURIComponent(this.strikeName)}`;

      }

    } else {

      endpoint += `${this.reportEndPoint}/${this.strikeID}?`;

      if (this.strikeName) {

        endpoint += `StrikeName=${encodeURIComponent(this.strikeName)}`;

      }

    }

    return endpoint;

  };

  reportEnpointParamsGenerator(endpoint: string, formData: formdata): string {

    for (const key in formData) {

      if (formData.hasOwnProperty(key) && key !== 'format' && key !== 'housename') {

        if (key.toLowerCase().includes('date')) {

          const datePipe = new DatePipe('en-US');

          formData[key] = datePipe.transform(formData[key], 'yyyy-MM-dd HH:mm:ss')

        }

        endpoint += `&${key}=${encodeURIComponent(formData[key])}`;

      }
    }

    return endpoint;

  };


  constructDynamicEndpoint(formData: formdata): string {

    // strike report endpoint format:
    // Strike Report: endpoint/id/format?strikeName?&params? or endpoint/id?strikeName?&params?
    // House Report: enpoint/id?houseName?&params?

    let dynamicEndpoint = ""

    if (formData) {

      dynamicEndpoint = this.reportEnpointBaseGenerator(dynamicEndpoint, formData);

      dynamicEndpoint = this.reportEnpointParamsGenerator(dynamicEndpoint, formData);
  
    } else {

      dynamicEndpoint = `${this.reportEndPoint}/${this.strikeID}?`;

      if (!(this.strikeName === "")) {

        dynamicEndpoint += `StrikeName=${encodeURIComponent(this.strikeName)}`;
      
      }

    }

    return dynamicEndpoint;

  }


  cancelAction() {
    // Close the modal without generating the report
    this.modalService.closeModal();
  }
}
